import { Injectable } from '@angular/core';
import { toolsConfig } from '../../../../cross-team-shared/tools.config';
import { AbstractTool2D } from '../shared/abstract-tool-2d';
import { OverlayRectangleDragHandler } from '../shared/drag-handlers/overlay-rectangle-drag-handler';

@Injectable()
export class MeasureTool extends AbstractTool2D {
  readonly name = toolsConfig.Measure.name;

  override async onActivate() {
    await super.onActivate();
    this.onEvent('container', 'mousedown', (event: MouseEvent) => {
      const dragHandler = new OverlayRectangleDragHandler(
        event,
        this.injector,
        true,
        {
          id: 'draw_measure_rectangle',
          bucket: 'navigation',
          sub_bucket: 'frame',
        },
      );
      dragHandler.drag(); // initiate the tracking on click
      this.registerHelper(dragHandler);
    });
  }
}
